var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert(".iframe-login-modal iframe[data-v-12]{overflow-y:auto;width:265px;height:725px;border:none}")
;(function(){module.exports = {
  props: ['loggedIn', 'hasCCookie'],
  mounted: function() {
    return typeof IframeLogin !== "undefined" && IframeLogin !== null ? IframeLogin.init({
      iframeLogin: {
        authenticated: false
      }
    }) : void 0;
  },
  computed: {
    shouldRender: function() {
      return !$('#login-modal').length;
    },
    src: function() {
      if (!this.loggedIn && this.hasCCookie) {
        return '/login/iframe';
      } else {
        return '/signup/iframe';
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function(){with(this){return (shouldRender)?_c('div',{staticClass:"modal iframe-login-modal",attrs:{"id":"login-modal","data-bhw":"LoginModal"}},[_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"close-modal icon-x"}),_v(" "),_c('iframe',{attrs:{"name":"modal-login","src":src}})])]):_e()}}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-12"
